import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './LinkInfo.css';
import Client from './components/Client';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { BASE_URL } from '../../store/config';
import Toast from '../Layout/components/Toast';
import axios from 'axios'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { ADD } from '../../common/common';

const CLIENT = 11;
const INDIVIDUAL = "individual";
const CORPORATION = "corporation";
class LinkInfo extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            dialogTitle: "",
            dialogState: ADD,
            dialogData: null,
            dialogType: CLIENT,
            showToast: false,
            toastMsg: "",
            toastState: "",
            ICType: "",
            code: "",
            isSubmit: false,
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    render() {
        const {
            ICType,
            dialogTitle,
            dialogData,
            dialogState,
            showToast,
            toastMsg,
            toastState,
            isSubmit
        } = this.state;
        const stepView = () => {
            if (!isSubmit) {
                return <div className="card c">
                    <Client
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={dialogData}
                        state={dialogState}
                        ICType={ICType}
                    ></Client>
                </div>
            } else {
                return <div className="completeWapper c">
                    <div className="complete h h-c">
                        <AssignmentTurnedInIcon></AssignmentTurnedInIcon>
                        <div className="text">Your info has successfully submitted, thank you!</div>
                    </div>
                </div>
            }
        }
        return (
            <Root>
                <AppBar position="absolute" color="default">
                    <Toolbar>
                        <div className="logo"></div>
                    </Toolbar>
                </AppBar>
                {stepView()}
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root >
        );
    }
    componentDidMount() {
        // let pathName = "http://47.100.220.54/linkinfo?code=794790b72b39d4ada69bdcc74c549e456c1a549e&target=";
        // let pathName = "http://47.100.220.54/linkinfo?code=71c0fdff85dfae8d90ef80157f0f36cd5f280279&target=corp";
        let pathName = this.props.location.search;
        let pathArr = pathName.split("?");
        console.log(pathName)
        if (pathArr.length > 1) {
            const paramsStr = pathArr[1];
            const paramsArr = paramsStr.split("&");
            const code = paramsArr[0].split("=")[1];
            const type = paramsArr[1].split("=")[1];
            let ICType = "";
            if (type === "") {
                ICType = INDIVIDUAL;
            } else if (type === "corp") {
                ICType = CORPORATION;
            }
            console.log(code, type, ICType)
            this.setState(() => ({
                ICType,
                code
            }))
        }
    }
    handleCreate(radioValue, data) {
        const { dialogType } = this.state;
        if (dialogType === CLIENT) {
            if (radioValue === INDIVIDUAL) {
                this.addIndividual(data)
            } else if (radioValue === CORPORATION) {
                this.addCorporation(data)
            }
        } else {
            console.log("create得到", data)
        }
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleClick() {
        this.setState(() => ({
            isSubmit: false
        }))
    }
    //------------request----------------
    addIndividual(obj) {
        const { code } = this.state;
        const params = {
            // related_parties: obj.related_parties,
            referral_source: obj.referral_source,
            note: obj.note,
            first_name: obj.first_name,
            last_name: obj.last_name,
            email: obj.email,
            wechat: obj.wechat,
            phone: obj.phone,
            code,
        }
        console.log(obj, code, params)
        axios.post(BASE_URL + 'eu/clients/individual', params).then((res) => {
            console.log(res)
            this.showToast("Added successfully", "success");
            this.setState(() => ({
                isSubmit: true
            }))
        }).catch((err) => {
            const msg = err.response.data.message;
            console.log(err)
            this.showToast(msg, "error");
        })
    }
    addCorporation(obj) {
        const { code } = this.state;
        const params = {
            // referral_source: obj.referral_source,
            // related_parties: obj.related_parties,
            note: obj.note,
            name: obj.name,
            address: obj.address,
            points_of_contact: obj.points_of_contact,
            // members: obj.members,
            code,
        }
        console.log(obj, code, params)
        axios.post(BASE_URL + 'eu/clients/corporation', params).then((res) => {
            console.log(res)
            this.showToast("Added successfully", "success");
            this.setState(() => ({
                isSubmit: true
            }))
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default withRouter(LinkInfo);